import React from 'react';

const FormStatus = ({ type, message }) => {
  if (!message) return null;
  return (
    <div
      className={`tf-status tf-status--${type || 'info'}`}
      role={type === 'error' ? 'alert' : 'status'}
      aria-live={type === 'error' ? 'assertive' : 'polite'}
    >
      {message}
    </div>
  );
};

export default FormStatus;
